/*
 * @Author: zyb
 * @Date: 2022-03-22 19:05:10
 * @LastEditors: ldx
 * @LastEditTime: 2024-01-18 18:13:03
 * @FilePath: \dev_2.0\src\network\newApi.js
 * @Description:
 */
import http from './http.js'

//分页查询新闻
export const getNewsByPage = (params, data) => {
  return http.get(
    `/oa/web/officialweb/getNewsByPage/${params.pageNum}/${params.pageSize}`,
    data
  );
};

//查询单条数据
export const getNewsById = (id) => {
  return http.get(`oa/oa-api-marketing/official/OfficialWebsite/getNewsById/${id}`);
};

//首页查询tab树
export const findCategoryTree = () => {
  // d73ad52b7add99d34b42c4808c29328b 这个是教育信息化设备的id，这里是写死，是为了渲染头部的tab
  return http.get(
    `/oa/oa-api-marketing/mini/product-category/findCategoryTree?moduleId=d73ad52b7add99d34b42c4808c29328b&equipmentId=7e940bc67810ffe47426b8fc71e01f3e`
  );
};

//查询产品详情 
export const getById = (id) => {
  return http.get(`oa/oa-api-marketing/mini/product-content/getById/${id}`);
};

//获取产品的列表-智能教育应用软件、教育化解决方案
export const listProductContent = (id) => {
  return http.get(
    `oa/oa-api-marketing/mini/product-content/listProductContent?productCategoryId=${id}`
  );
};

// 获取产品的列表-教育化设备
export const listProductCategory = (id) => {
  return http.get(
    `/oa/oa-api-marketing/mini/product-category/listProductCategory?productModuleId=${id}`
  );
};

// 查询分类列表
export const getOfficialNewsCategory = (id) => {
  return http.get(
    `/oa/oa-api-marketing/official/OfficialWebsite/getOfficialNewsCategory/${id}`
  );
};

// 分页查询
export const getCaseOrTainByPage = (params, data) => {
  return http.get(
    `/oa/oa-api-marketing/official/OfficialWebsite/getNewsByPage/${params.pageNum}/${params.pageSize}`,
    data
  );
};

//查询banner
export const getBannerList = (params, data) => {
  return http.get(`/oa/oa-api-marketing/official/OfficialWebsite/getBannerList`);
};

export const findContentById = (id) => {
  return http.get(
    `/oa/oa-api-marketing/mini/product-category/findContentById?productCategoryId=${id}`
  );
};
